
import NotificationList from './notification-list';

function NotificationsComponent() {
  return (
    <section className="pt-3">
      <div className="container">
        <div className="row">
          <NotificationList />
        </div>
      </div>
    </section>
  );
}

const Notifications = NotificationsComponent;
export default Notifications;
